import { Theme, css } from '@emotion/react';
import { formSection } from 'omakase/FormBlock/formBlockCssDefs';
import { isNil } from 'es-toolkit/compat';
import React from 'react';

interface FormSectionProps {
  className?: string;
  nested: boolean;
  background: boolean;
  box: boolean;
}

const FormSection: React.FunctionComponent<FormSectionProps> = ({
  children,
  nested,
  background,
  box,
  ...rest
}) => (
  <div css={(theme: Theme) => formSection(theme, { background, nested, box })} {...rest}>
    {React.Children.toArray(children)
      .filter((child) => !isNil(child))
      .map((child, index) => {
        return (
          <div
            data-testid={`child-container-${index}`}
            css={({ spacing }: Theme) => css`
              margin-top: ${spacing(index === 0 ? 0 : 3)}px;
            `}
            key={`block-${index}`}
          >
            {child}
          </div>
        );
      })}
  </div>
);

export default FormSection;
